import React, { useState, useEffect, Fragment } from "react";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import "react-toastify/dist/ReactToastify.css";
import Router from "next/router";
import {  toast } from "react-toastify";
import moment from "moment";
import axios from "axios";
import datesBetween from "dates-between";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Box from "@mui/material/Box";
import CryptoJS from "crypto-js";
import Drawer from "@mui/material/Drawer";
import darkTheme from '../../src/theme';
import ModalTitle from '../../components/modals/dealModal/title'
import ModalInfo from '../../components/modals/dealModal/info'
import ModalCheckOutContainer from '../../components/modals/dealModal/checkoutContainer'
import { Navigation, Pagination, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import ButtonGroup from "@mui/material/ButtonGroup";
import { nanoid } from 'nanoid'
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const dealsTicketsModal = {
  background: darkTheme.palette.background.default,
  // paddingLeft: 1,
  // paddingRight: 1,
  paddingTop: 0,  
  'h3': {
    fontSize: 14,
    fontWeight: 100,
    color: darkTheme.palette.primary.dates,    
    textTransform: 'capitalize',    
    marginTop: darkTheme.spacing(2),    
    marginTop: darkTheme.spacing(1),    
  }
  
};

function TicketsModal(props) {

  const encrypt = (text) => {
    return CryptoJS.AES.encrypt(text, process.env.ENCRYPTION_KEY).toString();
  }
  
  const decrypt = (encryptedText) => {
    const bytes  = CryptoJS.AES.decrypt(encryptedText, process.env.ENCRYPTION_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  }  
  const { open, onClose, onCloseAlert } = props;  
  const [openAlert, setOpenAlert] = useState(false);
  let [availDates, setAvailDates] = useState([]);
  let [eventArray, setEventArray] = useState([]);
  let [totalCost, setTotalCost] = useState(0);
  let [totalNoOfTickets, setTotalNoOfTickets] = useState(0);
  const [loading, setLoading] = useState(false);
  const [current_date_new, setCurrent_date_new] = useState('');
  useEffect(() => {
    let i = 0;
    let dates = [];
    const myArray = props.data.offer_days.split(",");    
    for (const d of datesBetween(
      new Date(props.data.offer_start_date),
      new Date(props.data.offer_end_date)
    )) {
      if (
        ( moment(new Date()).format("YYYY-MM-DD") <= moment(d).format("YYYY-MM-DD") && myArray.includes(moment(d).format("ddd").toLowerCase()))
      ) {
        dates[i] = moment(d).format("YYYY-MM-DD");        
        i++;
      }
    }
    setAvailDates(dates);
    setCurrent_date_new(dates[0]);
  }, []);
  
  function setCurrentDate(e, dt) {
    e.preventDefault();
    setCurrent_date_new(dt);
  }

  const eventCounterIncrease = (e) => {
    e.preventDefault();
    totalCost += parseInt(props.data.actual_price);
    totalNoOfTickets += 1;
    setTotalCost(totalCost);
    setTotalNoOfTickets(totalNoOfTickets);
    evaluateCartArray();
  };
  const eventCounterDecrease = (e) => {
    e.preventDefault();
    totalCost -= parseInt(props.data.actual_price);
    totalNoOfTickets -= 1;
    setTotalCost(totalCost);
    setTotalNoOfTickets(totalNoOfTickets);
    evaluateCartArray();
  };
  function evaluateCartArray() {
    let eventArray = [];
    if (totalNoOfTickets > 0) {
      eventArray.push({
        id: props.data.id,
        type: 1,
        title: props.data.title,
        numberOfTickets: totalNoOfTickets,
        persons: props.data.entry_free_upto,
        actual_price: props.data.actual_price,
        price: props.data.price,
        end_time: props.data.end_time,
        clubTitle: props.data.club_title,
        totalCost: totalCost,
        selected_date: props.data.days_type == 'm' ? current_date_new : props.data.only_today,
        booking_fee_payer: props.data.booking_fee_payer,
        payment_gateway_fee_payer: props.data.payment_gateway_fee_payer,
        booking_fee: props.data.booking_fee,
        payment_gateway_fee: props.data.payment_gateway_fee,
        money_to_you: props.data.money_to_you,
        total_paid_by_buyer: props.data.total_paid_by_buyer,
      });
    }
    setEventArray(eventArray);
  }

  async function onPageRedirect(e) {
    evaluateCartArray();
    e.preventDefault();
    setLoading(true);
    let tickets = JSON.stringify(eventArray);
    // console.log(tickets);
    let deal_id = props.data.id;
    let club_id = props.data.clubId;
    let new_data = {};

    new_data.tickets = tickets;
    new_data.identity_id = deal_id;
    new_data.club_id = club_id;
    new_data.cart_type = "deals";
    new_data.identity_details = props.data

    sessionStorage.setItem('cart', encrypt(JSON.stringify(new_data)));

    await axios
      .post(
        `/api/cart`,
        {
          data: encrypt(JSON.stringify(new_data)),
        },
        {
          headers: {
            "x-auth-token": process.env.JWT_TOKEN,
          },
        }
      )
      .then((response) => {
        const decrypted = JSON.parse(decrypt(response.data.data))
        if (response.status == 200) {
          // console.log(decrypted.token);
          if (decrypted.token) {
            let cart_id = decrypted.token;
            // setTimeout(() => {
              setLoading(false);
              Router.push({ pathname: "/cart/" + cart_id });
            // }, 3000);
            // window.location.href = "/cart/"+cart_id
          } else {
            setLoading(false);
            toast.error("Something went wrong, please reload then try", {
              position: toast.POSITION.BOTTOM_CENTER,
            });
          }
        }
        // if (response.status == 200) {
        //   if (response.data.token) {
        //     let cart_id = response.data.token;
        //     setLoading(false);
        //     Router.push({ pathname: "/cart/" + cart_id });
        //     axios
        //       .get(`/api/deals/dealDetailsById?id=${deal_id}`, {
        //         headers: {
        //           "x-auth-token": process.env.JWT_TOKEN,
        //         },
        //       })
        //       .then((response) => {
        //         if (response.status == 200) {
        //           const encrypted = response.data
        //             ? JSON.stringify(response.data.result[0])
        //             : JSON.stringify({});
        //           sessionStorage.setItem(
        //             "kjsfd5hk7s0a+fhk",
        //             CryptoJS.AES.encrypt(
        //               encrypted,
        //               process.env.ENCRYPTION_KEY
        //             ).toString()
        //           );
        //         }
        //       });
        //   } else {
        //     setLoading(false);
        //     toast.error("Something went wrong, please reload then try", {
        //       position: toast.POSITION.BOTTOM_CENTER,
        //     });
        //   }
        // }
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status == 406) {
            setLoading(false);
            toast.error("Something went wrong, please reload then try", {
              position: toast.POSITION.BOTTOM_CENTER,
            });
          }
        }
      });
  }

  const emptyBeforeClose = () => {
    setOpenAlert(true);
  };

  const closeAlertDialog = () => {
    setOpenAlert(false);
  };

  const removeSelectedTickets = (e) => {
    e.preventDefault();

    const emptyArray = [];
    setEventArray(emptyArray);
    setTotalCost(0);
    setOpenAlert(false);
    setTotalNoOfTickets(0);
    onCloseAlert();
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 350,
    bgcolor: darkTheme.palette.background.tickets,
    border: `1px solid ${darkTheme.palette.background.ticket}`,
    boxShadow: 24,
    p: 3,
    borderRadius: 2,
    color: darkTheme.palette.primary.title,
    height: 270    
  };


  const muiDrawer = {
    // width: '36%',    
    '& .MuiDrawer-paper': {
      background: darkTheme.palette.background.default,
      borderLeft:`1px solid ${darkTheme.palette.background.ticket}`,
      maxWidth: '36%',
      width: '36%',
      paddingBottom: darkTheme.spacing(12),
      borderRadius: '20px 0 0 0',
      [darkTheme.breakpoints.down("md")]: {
        width: '100%',
        maxWidth: '100%',
        borderLeft:'none'
      },
    }
  };

  const ticketContainer = {
    // background: darkTheme.palette.background.secondary,
    marginBottom: darkTheme.spacing(2),
    padding: darkTheme.spacing(2),            
    borderRadius: 3,    
    display: 'block',
    '& h4': {
      fontSize: 20,
      fontWeight: 500,  
      [darkTheme.breakpoints.down("md")]: {
        fontSize: 18,
        fontWeight: 100, 
      }
    }
  };

const calendarFilterDate = {
  border: `1px solid #3F3E46`,
  borderRadius: 2,
  background: `${darkTheme.palette.background.default}`,
  padding: 0.35, 
  height: `50px !important`,
  textAlign: 'center',  
  cursor: 'pointer',  
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width:65,
  '& h5': {
    fontSize: 12,
    color: darkTheme.palette.primary.location,
  },
  '& h6': {
    fontSize: 16,
    color: darkTheme.palette.primary.dates,
  }
};

const calendarFilterDateActive = {
  border: `1px solid ${darkTheme.palette.primary.main}`,
  borderRadius: 2,
  background: `${darkTheme.palette.primary.main}`,
  padding: 0.35,  
  height: `50px !important`,
  textAlign: 'center',  
  cursor: 'pointer',  
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',  
  width:65,
  '& h5': {
    fontSize: 12,
    color: darkTheme.palette.background.default,
  },
  '& h6': {
    fontSize: 16,
    color: darkTheme.palette.background.default,
  }
};

  return (
    <Fragment>
      {/* <Modal
        keepMounted
        open={openAlert}
        onClose={closeAlertDialog}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Alert
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{
              my: 4,
              color: "#ffffff90",
              fontSize: "16px",
            }}
          >
            All Selected Ticket(s) will be Removed
          </Typography>
          <Typography
            component="div"
            sx={{ mt: 4, justifyContent: "center", display: "flex" }}
          >
            <Button
              variant="outlined"              
              onClick={removeSelectedTickets}
            >
              Remove
            </Button>
            &nbsp;&nbsp;
            <Button
              variant="outlined"              
              onClick={closeAlertDialog}
            >
              Cancel
            </Button>
          </Typography>
        </Box>
      </Modal> */}
      <Dialog
          fullScreen
          open={openAlert}
          onClose={closeAlertDialog}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"          
          sx={{            
            backdropFilter: "blur(5px)",
          }}
        >
          <DialogContent>
          <Box sx={style}>
            <Stack display="flex" flexDirection="row" justifyContent="flex-end" alignItems="start">
              <Typography component="div" onClick={closeAlertDialog}>
                <CloseIcon sx={{ fontSize: 16, cursor: 'pointer', mb:3 }}/>
              </Typography>              
            </Stack>
            <Stack display="flex" flexDirection="row" justifyContent="center" alignItems="baseline">
              <Typography component="div"
                sx={{
                  background: darkTheme.palette.background.default,
                  padding: '10px',
                  width: 40,
                  height: 40,
                  borderRadius: 10,
                  mr: 1,
                  textAlign: 'center',                  
                }}>
                <WarningAmberIcon sx={{ fontSize: 18 }}/>
              </Typography>
              <Typography id="modal-modal-title" variant="h3" component="h2">
                Are you sure ?
              </Typography>
            </Stack>
          <Typography
            id="modal-modal-description"
            sx={{
              mb: 4,
              mt:2,
              color: "#ffffff90",
              fontSize: "16px",
              textAlign:'center'
            }}
          >
            All Selected Ticket(s) will be Removed
          </Typography>
          <Typography
            component="div"
            sx={{ mt: 4, justifyContent: "center", display: "flex" }}
          >
            <Button
              variant="contained"              
              onClick={removeSelectedTickets}
              sx={{fontWeight:500, color:darkTheme.palette.background.default}}
            >
              Confirm
            </Button>
            {/* &nbsp;&nbsp;
            <Button
              variant="outlined"              
              onClick={closeAlertDialog}
            >
              Cancel
            </Button> */}
          </Typography>
          </Box>
        </DialogContent>
        </Dialog>

      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        ModalProps={{
          keepMounted: true,
        }}
        hideBackdrop={true}         
        sx={{
          ...muiDrawer,
          backdropFilter: "blur(5px)",
        }}
        
      >
              
        <Box sx={dealsTicketsModal}>
          <ModalTitle data={props.data} totalNoOfTickets={totalNoOfTickets} onClose={onClose} emptyBeforeClose={emptyBeforeClose} />        
          <Typography component="div" sx={{px:2}} >
            {/* <ModalValidDates data={props.data} />               */}
            <Typography component="div" sx={ticketContainer}>
              <Stack
                sx={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 2,
                  mt: 1,
                }}
              >
                <Typography variant="h5" sx={{fontWeight:`400 !important`, fontSize: 14, color: darkTheme.palette.primary.dates, textTransform:'capitalize'}}>
                  {
                    props.data.days_type == 'm' ? 'Select Date' : 'Date'
                  }
                </Typography>
                <Typography variant="h5" sx={{fontWeight:`400 !important`, fontSize: 16, color: darkTheme.palette.primary.main}}>
                  {
                    moment(
                      props.data.days_type == 'm' ? current_date_new : props.data.only_today
                    ).format("ddd DD MMM, YYYY")
                  }
                </Typography>
              </Stack>
              <Typography component="div" sx={{width:'100%'}}>
              <Swiper
                  modules={[Navigation, Pagination]}
                  spaceBetween={15}
                  navigation
                  autoplay={false}
                  loop={false}
                  slidesPerView={4}
                  breakpoints={{
                      1023: {
                          width: 1023,
                          slidesPerView: 12,
                      },
                      990: {
                          width: 990,
                          slidesPerView: 10,
                      },
                      768: {
                          width: 768,
                          slidesPerView: 7,
                      },
                      425: {
                          width: 425,
                          slidesPerView: 4,
                      },
                  }}
              >   
                {availDates.map((item, index) => (
                  <SwiperSlide key={nanoid(30)}>
                    {current_date_new == item ? (
                      <Stack display="flex" flexDirection="column" justifyContent="center" onClick={(e) => setCurrentDate(e, item)} sx={calendarFilterDateActive} >
                        <Typography variant="h5">{moment(item).format("ddd")}</Typography>
                        <Typography variant="h6">{moment(item).format("DD")}</Typography>
                      </Stack>
                    ) : (
                      <Stack display="flex" flexDirection="column" justifyContent="center" onClick={(e) => setCurrentDate(e, item)} sx={calendarFilterDate} >
                        <Typography variant="h5">{moment(item).format("ddd")}</Typography>
                        <Typography variant="h6">{moment(item).format("DD")}</Typography>
                      </Stack>
                    )}
                  </SwiperSlide>
                ))}
              </Swiper> 

              </Typography>
              <Stack
                sx={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mt: 3,
                  p: 3,
                  background: darkTheme.palette.background.tickets,
                  borderRadius: "10px",
                  border:'1px solid #5D5D5D'
                }}
              >
                <Typography variant="h4" sx={{fontWeight:`400 !important`}}>Select Quantity</Typography>
                <Typography component="div">
                  <ButtonGroup
                    variant="outlined"
                    aria-label="outlined button group"
                  >
                    {totalNoOfTickets < 1 ? (
                      <Button
                        className="themeBtn"
                        variant="contained"
                        onClick={eventCounterIncrease}
                        sx={{
                          minWidth: "75px !important",p:1, fontSize: `12px !important`,fontWeight:`400 !important`
                        }}
                      >
                        {props.data.actual_price > 0 ? "Add" : "RSVP"}
                      </Button>
                    ) : (
                      <>
                          <Button
                            className="themeBtnRoundedLeft"
                        variant="contained"
                            onClick={eventCounterDecrease}
                            sx={{color: darkTheme.palette.background.default, fontSize: `14px !important`,p:0.6}}
                        >
                          -
                        </Button>
                          <Button
                            className="themeBtnRounded"
                            variant="contained"
                            sx={{color: darkTheme.palette.background.default, fontSize: `14px !important`,p:0.6}}
                          >
                          {totalNoOfTickets}
                        </Button>
                          <Button
                            className="themeBtnRoundedRight"
                        variant="contained"
                            onClick={eventCounterIncrease}
                            sx={{color: darkTheme.palette.background.default, fontSize: `14px !important`,p:0.6}}
                        >
                          +
                        </Button>
                      </>
                    )}
                  </ButtonGroup>
                </Typography>
              </Stack>
            </Typography>           
            <ModalInfo /> 
          </Typography>
          <Typography component="div" sx={{ position: 'relative' }}>
        {eventArray.length > 0 && (
          <ModalCheckOutContainer totalCost={totalCost} totalNoOfTickets={totalNoOfTickets} onPageRedirect={onPageRedirect} />
        )} 
        </Typography>
        </Box>
        
      </Drawer>
    </Fragment>
  );
}

export default TicketsModal;
